import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import LandingPage from "./pages/LandingPage.js";
import ParentPage from "./pages/ParentPage.js";
import TeacherPage from "./pages/TeacherPage.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="" element={<App />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/for-parents" element={<ParentPage />} />
          <Route path="/for-teachers" element={<TeacherPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

